module.exports = __webpack_public_path__ + "img/wupao.29d8a585.png";